import { GetCurrentUser200 } from '@platform/client/schemas';
import { useEffect } from 'react';
import hotjarPkg from 'react-hotjar';
import { useConsent } from './useConsent';
// Special import boilerplate as react-hotjar is commonjs
const { hotjar } = hotjarPkg;

export const HOTJAR_ENABLED =
  // We don't have a dev environment for hotjar
  import.meta.env.VITE_ENVIRONMENT === 'production' &&
  !import.meta.env.SSR &&
  !!import.meta.env.VITE_HOTJAR_ID?.length &&
  import.meta.env.VITE_ANALYTICS_ENABLED;

export const initHotjar = () => {
  if (!HOTJAR_ENABLED) {
    return false;
  }
  hotjar.initialize({ id: import.meta.env.VITE_HOTJAR_ID, sv: 6 }); // Hotjar snippet version 6
  return true;
};

/** confirms hotjar is enabled and user has consented then identifies the user */
export const useIdentifyHotjarUser = (user?: GetCurrentUser200) => {
  const { consent } = useConsent();
  useEffect(() => {
    if (!HOTJAR_ENABLED || !consent.analytics || !consent.initialized || !user) {
      return;
    }
    hotjar.identify(user.userId.toString(), {
      user_id: user.userId.toString(),
      $role: user.role,
      $email: user.userName,
      $first_name: user.firstName,
      $last_name: user.lastName,
    });
  }, [user, consent.analytics, consent.initialized]);
};
